import { i18n } from "../../i18n/i18n";

import React, { Component, ReactNode } from 'react'
import palletApi, { PalletData } from '../../apis/pallet.api'
import { CaseData } from '../../apis/inventoryCase.api'
import printService from '../../services/print.service'
import Card from '../../components/Card'
import PageHeading from '../../components/PageHeading'
import RadioGroup, { RadioGroupItem } from '../../components/RadioGroup'
import TransferToProduction from './TransferToProduction'
import TransferToPallet from './TransferToPallet'

type TransferTo = 'pallet' | 'production'

interface CaseTransferFormProps {
  selectedCases: number[]
  children: ReactNode
  onSourcePalletChange: (pallet: PalletData | null) => void
  onConsumeCaseChange: (consumeCase: CaseData | null) => void
  onCaseScan: (inventoryCase: CaseData) => void
  onResetForm: () => void
}

interface CaseTransferFormState {
  transferTo: TransferTo
}

export default class CaseTransferForm
  extends Component<CaseTransferFormProps, CaseTransferFormState> {
  transferToRadios: RadioGroupItem[] = [
    { name: 'pallet', label: 'Pallet' },
    { name: 'production', label: 'Production' }
  ]

  constructor (props: CaseTransferFormProps) {
    super(props)
    this.state = {
      transferTo: 'pallet'
    }
    this.handleRadioChange = this.handleRadioChange.bind(this)
  }

  printPalletLabel (palletId: number, callback: () => void) {
    palletApi.print(palletId, markups => {
      if (!markups) return
      printService.printMarkups(markups)
      callback()
    })
  }

  handleRadioChange (name: string) {
    this.setState({ transferTo: name as TransferTo })
    this.props.onResetForm()
  }

  get form () {
    const { selectedCases, onSourcePalletChange } = this.props
    const { onCaseScan, onResetForm, onConsumeCaseChange } = this.props
    switch (this.state.transferTo) {
      case 'pallet':
        return (
          <TransferToPallet
            selectedCases={selectedCases}
            onSourcePalletChange={onSourcePalletChange}
            onCaseScan={onCaseScan}
            onResetForm={onResetForm}>
            {this.props.children}
          </TransferToPallet>
        )
      case 'production':
        return <TransferToProduction
          onCaseChange={onConsumeCaseChange}
          onResetForm={onResetForm}/>
    }
  }

  render () {
    return (
      <Card>
        <PageHeading
          text={i18n("Case Transfer")}
          doc='cases-case-transfer-to-pallet' />
        <RadioGroup
          label={i18n('Transfer to')}
          radios={this.transferToRadios}
          checked={this.state.transferTo}
          onChange={this.handleRadioChange} />
        {this.form}
      </Card>
    )
  }
}
